import ReactGA from "react-ga";
export default function getGA() {
  const pathName = window.location.pathname;
  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);
  ReactGA.set({ page: pathName });
  ReactGA.pageview(pathName);
}
